<section class="text-section">
    <div class="container">
        <h1 class="intro-title">Terms of <span>Use</span></h1>
        <h2 class="subtitle">1. Agreement</h2>
        <div class="text">You shall carefully read through this agreement before using Realis, and pay close attention
            to the written content. By clicking the «Accept» button below, you agree that this Agreement is enforceable
            like any written contract signed by you. You can contact Realis if you have any questions about this
            Agreement.<br><br>However, regardless whether you have carefully read through this agreement before using
            Realis, you shall be bound by this agreement as long as you use Realis. You shall not claim to void or
            rescind this agreement on the ground that you did not read this agreement or you did not receive any respond
            from Realis to your consultation.<br><br>You hereby promise to accept and observe this agreement. If you do
            not agree to this agreement, you shall immediately stop registration or using Realis Service.<br><br>Realis
            may make or amend this agreement and various rules from time to time as needed, and announce the same on the
            website or social networks, without any individual notice to you. The amended agreement and rules shall come
            into effect immediately and automatically upon being announced on the website.<br><br>If you do not agree to
            the relevant amendment, you shall immediately stop using Realis. If you continue using Realis, you shall be
            deemed as having accepted the amended agreement and rules.<br><br>Realis disclaims any promises or
            guarantees regarding to the effectiveness, compliance, reliability, quality, stability, completeness and
            timeliness of the technology and the information related to the work of the game. You are fully aware
            information about Realis can contain risks and shortcomings.
        </div>
        <h2 class="subtitle">2. Registration and Account</h2>
        <h3 class="subtitle">2.1. Eligible age</h3>
        <div class="text">To create and use an Account you must be at least 18 years of age.</div>
        <h3 class="subtitle">2.2. Eligibility of Registrants</h3>
        <div class="text">You hereby confirm that you are an individual 13 years old when you complete the registration
            or actually use Realis. If you’re at least 13 years old, but not yet legally considered an «adult» in the
            country you live in, you must ask one of your parents (or other legal guardians) to read this Agreement and
            accept it on your behalf. You may not create or use an account on behalf of a legal entity or for a
            commercial purpose. Also, you confirm that you are not a citizen of the Republic of China.<br><br>Realis
            accounts can only be used by the person whose name they are registered under. Realis reserves the right to
            suspend, freeze, or cancel accounts that are used by persons other than the persons whose names the accounts
            are registered under. Realis will also not take legal responsibility for these accounts.
        </div>
        <h3 class="subtitle">2.3. User’s information</h3>
        <div class="text">You may log in Realis by your Google Mail address or Facebook social network account that you
            have provided and confirmed. If any information you have provided during the registration is inaccurate,
            Realis will not take any responsibility and any loss, direct or indirect, and adverse consequence resulted
            therefrom will be borne by you.<br><br>When you create an account with us, we require you to select an
            unique username and password, which you’ll use each time you access Realis. You can’t share your account or
            login credentials with anyone. You can’t sell, transfer or allow any other person to access your account or
            login credentials, or offer to do so. You’re entirely responsible for maintaining the confidentiality of
            your login credentials. Please notify us immediately if you become aware of any breach of security,
            including any loss, theft or unauthorized disclosure of your login credentials.<br><br>During the
            activation, you consent to the processing of your personal information. You shall accurately provide and
            timely update your information by following the instructions on the relevant page according to the laws and
            regulations in order to make it truthful, timely, complete and accurate. If there is any reasonable doubt
            that any information provided by you is wrong, untruthful, outdated or incomplete, Realis shall have the
            right to send you a notice to make enquiry and demand corrections, remove relevant information directly and,
            as the case may be, terminate all or part of Realis to you. Realis will not take any responsibility and any
            loss, direct or indirect, and adverse consequence resulted therefrom will be borne by you.<br><br>You shall
            accurately fill in and timely update your email address, telephone number, contact address, postal code and
            other contact information so that Realis will be able to effectively contact you. You shall be solely and
            fully responsible for any loss or extra expenses incurred during the use of Realis by you.
        </div>
        <h3 class="subtitle">2.4. Account Security</h3>
        <div class="text">You shall be solely responsible for the safekeeping of your Realis account and password on
            your own, and you shall be responsible for all activities under your log-in email, Realis account and
            password.<br><br>You hereby agree that:<br>a) you will notify Realis immediately if you are aware of any
            unauthorized use of your Realis account and password by any person or any other violations to the security
            rules;<br>b) you will strictly observe the security, authentication, dealing and procedures of the
            website/service;<br>c) you will log out the website by taking proper steps at the end of every
            visit.<br><br>Realis shall not and will not be responsible for any loss caused by your failure to comply
            with this provision. You understand that Realis needs reasonable time to take actions upon your request, and
            Realis will not undertake any responsibility for the consequences (including but not limited to any of your
            loss) that have occurred prior to such actions.
        </div>
        <h2 class="subtitle">3. User’s Guide</h2>
        <div class="text">You hereby promise to observe the following covenants during your use of Realis: All the
            activities that you carry out during the use of Realis will be in compliance with the requirements of laws,
            regulations, regulatory documents and various rules of Realis, will not be in violation of public interests,
            public ethnics or other’s legitimate interests, will not constitute evasion of payable taxes or fees and
            will not violate this agreement or relevant rules.<br><br>You will not use any data on Realis for commercial
            purposes, including but not limited to using any data displayed on Realis through copy, dissemination or any
            other means without prior written consent of Realis.<br><br>You will not use any device, software or
            subroutine to intervene or attempt to intervene the normal operation of Realis.<br><br>You acknowledge and
            agree: Realis shall have the right to unilaterally determine whether you have violated any of the covenants
            above and, according to such unilateral determination, apply relevant rules and take actions thereunder or
            terminate services to you, without your consent or prior notice to you.<br><br>As to any information/act you
            may have published on Realis that allegedly violates or infringes upon the law, other’s legitimate interests
            or this agreement, Realis shall have the right to delete such information without any notice to you and
            impose punishments according to the rules.<br><br>You shall keep all the evidence related to your acts on
            your own and shall undertake all the adverse consequences resulted from your failure to discharge your
            burden of proof.
        </div>
        <h2 class="subtitle">4. Limitation of Liability</h2>
        <div class="text">Under no circumstances, and under no legal theory, whether in contract, tort (including
            negligence), strict liability or otherwise, Realis be liable to you or any other person for any indirect,
            incidental, consequential, special, exemplary, or punitive damages of any kind (including, damages for loss
            of business, loss of data, loss of good will, or lost profits), or any damages for gross negligence of any
            kind (including, damages for work stoppage, computer failure or malfunction, or any other commercial damages
            or losses) arising from your use or misuse of the Realis, even if Realis knew or should have known of the
            possibility of such damages.
        </div>
        <h2 class="subtitle">5. Termination of Agreement</h2>
        <div class="text">You hereby agree that, Realis shall have the right to terminate all or part of Realis to you
            without any prior notice, for whatsoever reason. Realis shall not be liable to you. However, Realis shall
            have the right to keep and use data, records and other information that is related to such account.<br><br>In
            case of any of the following events, Realis shall have the right to directly terminate this agreement by
            cancelling your account, and shall have the right to permanently freeze (cancel) the authorizations of your
            account on Realis and withdraw the corresponding Realis account thereof: after Realis terminates services to
            you, you allegedly register or register in any other person’s name as Realis user again, directly or
            indirectly the main content of user’s information that you have provided is untruthful, inaccurate, outdated
            or incomplete when this agreement is amended, you expressly state and notify Realis of your unwillingness to
            accept the amended service agreement any other circumstances where Realis deems it should terminate the
            services.<br><br>After the account service is terminated, the account in Realis is permanently frozen
            (cancelled). Realis shall not have any duty to keep or disclose to you or any third party any information in
            your account.<br><br>You agree that, after the termination of agreement between you and Realis, Realis shall
            still have the rights to keep your user’s information and all the information during your use of Realis.
        </div>
    </div>
</section>

<style>
    .text-section {
        padding: 125px 0 0;
        position: relative;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        color: white;
        margin: 0 0 40px;
        line-height: 90px;
        text-transform: uppercase;
        text-align: center;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .text {
        font-size: 18px;
        color: white;
        line-height: 1.4;
        margin-bottom: 80px;
        text-align: justify;
    }

    .subtitle {
        font-size: 26px;
        color: white;
        margin: 20px 0;
        line-height: 1.4;
    }

    h3.subtitle {
        font-size: 22px;
    }

    @media (max-width: 992px) {
        .intro-title {
            font-size: 44px;
        }

        .text {
            margin-bottom: 60px;
        }
    }

    @media (max-width: 767px) {
        .text-section {
            padding: 80px 0 0;
        }

        .intro-title {
            font-size: 30px;
            margin-bottom: 10px;
        }

        .text {
            font-size: 14px;
            margin-bottom: 30px;
        }

        .subtitle {
            font-size: 24px;
            margin: 10px 0;
        }

        .text + h3.subtitle {
            font-size: 20px;
        }
    }
</style>
